import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, Divider, Typography } from "@mui/material";

import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MSLoginButton from "./MSLoginButton";
import AppLoginForm from "./AppLoginForm";
import { useAuthContext } from "../../context/authContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  React.useEffect(() => {
    if (user?.id) {
      navigate("/");
    }
  }, [navigate, user]);

  const onGoBack = () => {
    navigate("/");
  };

  return (
    <Box>
      <CssBaseline />
      <Card
        sx={{
          mx: { xs: "3rem", md: "auto" },
          marginTop: 18,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 5,
          pb: 6,
          width: 450,
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Welcome to ChinookDT
        </Typography>
        <Typography variant="body1">Members only login</Typography>

        <br />

        <AppLoginForm />

        <Divider sx={{ my: 1.5, width: "100%" }}>or</Divider>
        <MSLoginButton />

        <Button onClick={onGoBack} sx={{ mt: 2, textDecoration: "underline" }}>
          Go back
        </Button>
      </Card>
    </Box>
  );
}
